<template>
<div class="fill-height mt-3">
	<v-row class="d-flex justify-center ">
		<!-- dialog add employee -->
		<v-dialog v-model="dialog" width="500">
			<v-card class="rounded-lg pa-2">
				<v-card-title class=" px-2 pb-0 pt-3"> 
					{{ userId ? 'Edit user' : 'Add user' }} 
				</v-card-title>
				<v-form ref="form">
					<v-card-text class="pt-3">
						<v-row class="pt-0">
							<!-- name -->
							<v-col cols="6" class="pby-1 px-1">
								<v-text-field
									v-model="dataDialog.name"
									label="Name"
									dense
									filled
									hide-details
									class="rounded-lg input"
									prepend-icon="mdi-account-tie"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
								></v-text-field>
							</v-col>

							<!-- status -->
							<v-col cols="2" class="py-1 px-1">
								<v-checkbox
									v-model="dataDialog.status"
									label="IsActive"
									dense
									filled
									hide-details
									class="rounded-lg"
								></v-checkbox>
							</v-col>

							<v-col cols="4" class="py-1 px-4">
								<v-checkbox
									v-model="dataDialog.isSupervisor"
									label="IsSupervisor"
									dense
									filled
									hide-details
									class="rounded-lg"
								></v-checkbox>
							</v-col>

							<!-- email -->
							<v-col cols="6" class="pby-1 px-1">
								<v-text-field
									v-model.number="dataDialog.workHours"
									label="Number of working hours"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
									dense
									filled
									hide-details
									class="rounded-lg input"
									prepend-icon="mdi-hours-12 "
									:rules="[val => val > 0 && val < 13]"
								></v-text-field>
							</v-col>

							<!-- email -->
							<v-col cols="6" class="pby-1 px-1">
								<v-text-field
									v-model="dataDialog.email"
									label="Email"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
									dense
									filled
									hide-details
									class="rounded-lg input"
									prepend-icon="mdi-email"
									:rules="rules.required"
								></v-text-field>
							</v-col>

							<v-col cols="6" class="pby-1 px-1">
								<v-text-field
									v-model="dataDialog.userName"
									label="Username"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
									dense
									filled
									hide-details
									class="rounded-lg input"
									prepend-icon="mdi-account"
									:rules="rules.required"
								></v-text-field>
							</v-col>

							<v-col cols="6" class="pby-1 px-1">
								<v-text-field
									v-model="dataDialog.password"
									label="Password"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
									dense
									filled
									hide-details
									class="rounded-lg input"
									prepend-icon="mdi-lock" 
                                    id="Password"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="showPassword = !showPassword"
                                    name="password"
                                    :type="showPassword ? 'text' : 'password'"
									:rules="userId ? [] : rules.required"
								></v-text-field>
							</v-col>

							<!-- type -->
							<v-col cols="6" class="pb-0 pt-2 pby-1 px-1">
								<v-autocomplete
									v-model="dataDialog.type"
									label="Type"
									:items="userTypeArray"
									item-text="name"
									item-value="id"
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									solo
									dense
									filled
									hide-details 
									class="rounded-lg input"
									prepend-icon="mdi-format-list-bulleted-type "
									:rules="rules.requiredAsNumber"
								/>
							</v-col>

							<v-col cols="6" class="pb-0 pt-2 pby-1 px-1">
								<bee-date-picker
									v-model="dataDialog.hireDate"
									input-label="Date"
									input-format-order="DD-MM-YYYY"
									dense
									hide-details="auto"
									menu-picker
									months-over-max="1"
									:rules="rules.required"
									:input-props="{
										readonly: true,
										outlined: false,
										filled: false,
										dense: true,
										clearable: true,
										prependIcon: 'mdi-calendar-plus',
										backgroundColor: 'grey lighten-5'
									}"
								></bee-date-picker>
							</v-col>

							<v-col v-if="!userId" cols="12" class="pb-0 pt-2 pby-1 px-1">
								<v-autocomplete
									v-model="dataDialog.employeeId"
									:items="unlinkedEmployees"
									:item-text="(item) => `${item.arabicFirstName}` + ' ' + `${item.arabicLastName}`"
									item-value="id"
									label="Employee"
									solo
									:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
									dense
									filled
									hide-details 
									class="rounded-lg input"
									prepend-icon="mdi-account-convert"
									
								/>
									<!-- :rules="rules.required" -->
							</v-col>
						</v-row>
					</v-card-text>
				</v-form>
				<v-card-actions>
					<v-spacer />
					<v-btn
						@click="save()"
						color="green-color white--text"
						:loading="submitLoading"
						class="text-none rounded-lg"
					>
						Save
					</v-btn>			
					<v-btn
						@click=" dialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- dialog status -->
		<v-dialog v-model="statusDialog" width="400">
			<v-card class="rounded-lg pa-1">
				<v-card-title class="d-flex w-100 ms-0 pt-3 pb-1 Urbanist-font">Edit user status</v-card-title>

				<v-card-text class="Urbanist-font py-0 ">
					Are you sure you want change status this user ?
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn
						color="alert-color white--text"
						@click="changeStatus()"
						:loading="submitLoading"
						class="rounded-lg text-none"
					>
						Yes
					</v-btn>

					<v-btn
						text
						@click="statusDialog = false; fetchByPage()"
						:disabled="submitLoading"
						class="text-none"
					> 
						Cancel 
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- dialog delete -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card class="rounded-lg pa-1">
				<v-card-title class="d-flex w-100 ms-0 pt-3 pb-1 Urbanist-font">Delete user</v-card-title>

				<v-card-text class="Urbanist-font py-0">
					Are you sure you want to delete this user ?
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn
						color="alert-color white--text"
						@click="deleteUser()"
						:loading="submitLoading"
						class="rounded-lg text-none"
					>
						Yes
					</v-btn>

					<v-btn
						text
						@click="deleteDialog = false"
						:disabled="submitLoading"
						class="text-none"
					> 
						Cancel 
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card
			:width="$vuetify.breakpoint.width - 100"
			:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null"
			class="rounded-lg mt-3"
		>	
			<v-card-text :height="$vuetify.breakpoint.height - 200">
				<!-- header -->
				<v-row class="mt-0 mb-1">
					<v-col cols="2" align-self="center" class="px-1 py-0">
						<v-autocomplete 
							v-model="type"
							:items="userTypeArray"
							item-text="name"
							item-value="id"
							label="Type"
							filled
							hide-details
							:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
							solo
							dense
							class="rounded-lg input"
						/>
					</v-col>

					<v-col cols="auto" align-self="center" class="px-1 py-0">
						Sort By:
						<v-btn-toggle
							v-model="sortBy"
							mandatory
							dense
							class="rounded-lg"
							color="primary"
							@change="isSearch = true; fetchByPage()"
						>
							<v-btn :disabled="loading" class="text-none">Name</v-btn>
							<v-btn :disabled="loading" class="text-none"> Hiring date </v-btn>
						</v-btn-toggle>
					</v-col>
				
					<v-col cols="auto" align-self="center" class="px-1 py-0">
						<v-btn-toggle
							v-model="status"
							mandatory
							dense
							class="rounded-lg"
							color="primary"
							@change="isSearch = true; fetchByPage()"
						>
							<v-btn
								:disabled="loading"
								class="text-none"
							>
								All
							</v-btn>

							<v-btn
								:disabled="loading"
								class="text-none"
							>
								Active
							</v-btn>

							<v-btn
								:disabled="loading"
								class="text-none"
							>
								Deactivated
							</v-btn>
						</v-btn-toggle>
					</v-col>

					<v-col cols="auto" align-self="center" class="px-1 py-0">
						<v-btn
							class="mx-2 rounded-lg text-none"
							color="dark-blue white--text"
							:disabled="loading"
							@click="isSearch = true; fetchByPage()"
						>
							Search
						</v-btn>

						<v-btn 
							@click="resetFilter()" 
							class="rounded-lg text-none" 
							color="alert-color white--text" 
							:disabled="loading"
						>
							Cancel
						</v-btn>
					</v-col>
		
					<!-- <v-divider v-if="$vuetify.breakpoint.mdAndUp"  vertical class="py-1" /> -->
					<v-spacer />
					<v-col
						align-self="center"
						cols="12"
						sm="auto"
						class="d-flex justify-start justify-sm-end pb-0 pb-sm-1 pt-0 px-1 my-2"
					>
						<v-btn
							color="success-light white--text"
							class="rounded-lg text-none"
							@click="dialog = true"
							:disabled="loading"
						>
							Create new user
						</v-btn>
					</v-col>
				</v-row>
				<!-- table employee -->
				<v-col cols="12" class=" px-0">
					<bee-handy-table
						ref="table"
						:headers="headers"
						:items="[]"
						dense
						zebra
						:height="$vuetify.breakpoint.height - 220"
						:width="$vuetify.breakpoint.width - 100"
						fixed-header
						:loading="loading"
						pagination-on-scroll
						pagination-on-scroll-server-items
						:options-scroll.sync="optionsScroll"
						:pagination-on-scroll-auto-reset-shown="false"
						:server-items-length="serverItemsLength"
						:items-per-page="20"
						@pagination-on-scroll:reach-last-row="fetchByPage"
						table-class="elevation-0"
						class="mt-0"
					>
						<!-- <template v-slot:item.active="{ item }">
							<v-switch
								v-model.number="item.active"
								dense
								hide-details
								class="mt-0"
								@click="statusDialog = true; userId = item.id"
								:loading="submitLoading"
							>
							</v-switch>
						</template> -->
						<template v-slot:item.name="{ item }">
							<span class="zain-regular"> 
								{{
									allEmployees.find(c => c.id === item.employeeId)?.arabicFirstName + ' '
									+ allEmployees.find(c => c.id === item.employeeId)?.arabicLastName
								}} 
							</span>
						</template>

						<template v-slot:item.isSupervisor="{ item }">
							<v-icon v-if="item.isSupervisor" color="success"> mdi-check-circle </v-icon>
							<v-icon v-else> mdi-close-circle </v-icon>
						</template>
						<!-- actions -->
						<template v-slot:item.actions="{ item, index }">
							<div class="d-flex justify-center align-center">
								<v-switch
									v-model="item.isActive"
									:true-value="true"
									:false-value="false"
									dense
									hide-details
									class="mt-0"
									@click="statusDialog = true; userId = item.id"
									:loading="changeStatusLoading"
									color="dark-blue"
									:disabled="loading"
								>
								</v-switch>

								<v-btn
									icon
									@click="userId = item.id; getUserById(item.employeeId)"
									:loading="submitLoad[index]"
									:disabled="loading"
								>
									<v-icon
										class="mr-2"
										color="edit-color"
									>
										mdi-pencil
									</v-icon>
								</v-btn>
							
								<v-btn 
									icon 
									@click="userId = item.id; $router.push({
										name: 'employee-bee',
										query: {
											id: userId
										} 
									})"
									:disabled="loading"
								>
									<v-icon
										color="alert-color"
									>
										mdi-chart-bar 
									</v-icon>
								</v-btn>

								<v-btn 
									icon
									@click="userId = item.id; deleteDialog = true"
									:disabled="loading"
								>
									<v-icon
										color="alert-color"
									>
										mdi-delete 
									</v-icon>
								</v-btn>
							</div>
						</template>
					</bee-handy-table>
				</v-col>
			</v-card-text>
		</v-card>

		<!-- snackbar shown when problem has occurred -->
		<v-snackbar v-model="snackbar" color="alert-color">
			A problem has occurred
			<template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
	</v-row>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { userType, userTypeArray } from '@/helper/enum'
import rules from '@/helper/validation rules.js'
import moment from 'moment'
export default {
	data () {
		return {
			deleteDialog: false,
			type: null,
			sortBy: null,
			status: 1,
			userType,
			userTypeArray,
			dialog: false,
			loading: false,
			submitLoading: false,
			tableInputs: {},
			submitLoad: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
			desserts: [
				{
					name: 'Rasha',
					type: 'Developer',
					situation: 'Active'
				}
			],
			dataDialog: {
				name: null,
				type: null,
				situation: 0,
				email: null,
				userName: null,
				password: null,
				status: 1,
				employeeId: null,
				isSupervisor: false,
				workHours: 0,
				hireDate: null
			},
			userId: null,
			optionsScroll: {},
			serverItemsLength: 0,
			entries: [],
			snackbar: false,
			employee: [],
			statusDialog: false,
			changeStatusLoading: false,
			showPassword: false,
			isSearch: false,
			rules
		}
	},

	watch: {
		dialog (val) { 
			if (val === false) {
				this.dataDialog.name = null
				this.dataDialog.type = null
				this.dataDialog.isSupervisor = false
				this.dataDialog.situation = 0
				this.dataDialog.email = null
				this.dataDialog.userName = null
				this.dataDialog.password = null
				this.dataDialog.status = 1
				this.userId = null
				this.dataDialog.employeeId = null
				this.dataDialog.workHours = null
				this.dataDialog.hireDate = null
				this.$refs.form.resetValidation()
			}
		}
	},

	computed: {
		...mapState({
			// sections: state => state.sections.sections.data
			// employees: state => state.users.employees,
			allEmployees: state => state.users.allEmployees,
			unlinkedEmployees: state => state.users.unlinkedEmployees
		}),

		headers () {
			const headers = [
				{ 
					text: 'Name', 
					name: 'name', 
					value: 'employeeId', 
					// setValueExpr: val => this/.allEmployees.find(c => c.employeeId === val)?.arabicFullName,
					align: 'center' 
				},
				{ 
					text: 'Type', 
					name: 'type',
					value: 'userType',
					setValueExpr: val => { 
						if (val === userType.Developer || val === '-') { 
							return 'Developer' 
						} else if (val === userType.Employee) {
							return 'Employee'
						} else if (val === userType.Administrative) {
							return 'Administrative'
						} else {
							return 'Admin'
						}
					},
					align: 'center' 
				},
				{
					text: 'isSupervisor',
					name: 'isSupervisor',
					value: 'isSupervisor'
				},
				// { 
				// 	text: 'situation',
				// 	name: 'active', 
				// 	value: 'active',
				// 	align: 'center', 
				// 	width: '15%',
				// 	classCell: 'd-flex justify-center' 
				// },
				{ 
					text: 'actions', 
					name: 'actions', 
					value: 'actions', 
					align: 'center' 
				}
			]

			return headers
		}
	},

	methods: {
		moment,
		
		statusEmployees () {
			console.log(this.status)
			let newStatus = null
			if (this.status === 0) {
				newStatus = null
			} else if (this.status === 1) {
				newStatus = true 
			} else if (this.status === 2) {
				newStatus = false
			}
			return newStatus
		},

		changeStatus () {
			this.submitLoading = true
			this.changeStatusLoading = true
			this.$store.dispatch('users/changeStatus', { id: this.userId }).then(() => {
				this.fetchByPage()
				this.statusDialog = false
			}).finally(() => {
				this.changeStatusLoading = false
				this.submitLoading = false
			})
		},

		save () {
			const actionName = this.userId ? 'update' : 'create'
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				this.$store.dispatch(`users/${actionName}`, {
					id: this.userId, 
					// employeeId: this.dataDialog.employeeId,
					employeeId: '1f2ee45e-5042-4953-1670-08dcc5d66e26',
					email: this.dataDialog.email,
					username: this.dataDialog.userName,
					userType: this.dataDialog.type,
					isActive: Boolean(this.dataDialog.status),
					password: this.dataDialog.password,
					isSupervisor: this.dataDialog.isSupervisor,
					workHours: this.dataDialog.workHours,
					hireDate: this.dataDialog.hireDate
					// name: this.dataDialog.name, 
					// sectionId: this.dataDialog.type,
					// id: this.userId !== null ? this.userId : null
				}).then(() => {
					this.isSearch = true
					this.fetchByPage()
					this.fetchUnlinkedEmployee()
				}).finally(() => {
					this.submitLoading = false;	
					this.dialog = false
					this.userId = null
				})
			}
		},

		fetchByPage (newOptionsScroll) {
			this.loading = true
			let page = 1;
			if (newOptionsScroll) {
				page = newOptionsScroll.page
			}
			return this.$store.dispatch('users/fetchAll', { 
				Page: page, 
				PerPage: 20,
				UserType: this.type, 
				IsActive: this.statusEmployees(),
				OrderByName: this.sortBy === 0,
				OrderByHiringDate: this.sortBy === 1,
				NonDeleted: true
			})
				.then((data) => {
					if (page === 1 || this.isSearch === true) { 
						this.$refs.table.resetShownRows() 
					}
					this.$refs.table.addScrollItems(data.data);
					this.serverItemsLength = data.total
				}).finally(() => {
					this.loading = false
					this.isSearch = false
				})
		},

		getUserById (userId) {
			this.submitLoading = true
			this.$store.dispatch('users/getEmployeeByEmployeeId', { id: userId }).then((data) => {
				this.dataDialog.name = this.allEmployees.find(c => c.id === data.data.employeeId)?.arabicFirstName + ' ' + this.allEmployees.find(c => c.id === data.data.employeeId)?.arabicLastName 
				this.dataDialog.type = data.data.userType
				this.dataDialog.situation = !data.data.isActive
				this.dataDialog.email = data.data.email
				this.dataDialog.userName = data.data.username
				this.dataDialog.isSupervisor = data.data.isSupervisor !== null ? data.data.isSupervisor : false
				// this.dataDialog.password = ,
				this.dataDialog.status = data.data.isActive
				this.dataDialog.employeeId = data.data.employeeId
				this.dataDialog.workHours = data.data.workHours
				this.dataDialog.hireDate = moment(data.data.hireDate).format('YYYY-MM-DD')
				this.submitLoading = false
				this.dialog = true
			})
		}, 

		deleteUser () {
			this.submitLoading = true
			this.$store.dispatch('users/delete', { id: this.userId }).then(() => {
				this.submitLoading = false
				this.deleteDialog = false	
				this.isSearch = true
				this.fetchByPage()
			})
		},

		resetFilter () {
			this.type = null
			this.sortBy = null
			this.status = 0
			this.fetchByPage()
		},

		fetchUnlinkedEmployee () {
			return this.$store.dispatch('users/fetchEmployeeUnLinked')
		}
	},

	created () {
		this.loading = true
		Promise.all([
			// !this.allEmployees.length ? 
			this.$store.dispatch('users/fetchAllEmployees') 
			// : null
		])
		if (!this.unlinkedEmployees.length) this.fetchUnlinkedEmployee()
		this.fetchByPage().catch(() => {
			this.snackbar = true
		}).finally(() => {
			this.loading = false
		})
		// this.$store.dispatch('sections/fetchAll')
	}
}
</script>

<style scoped>
.w-100 {
	width: 100%;
	margin-left: 3rem;
}

.week-card {
	height: 598px
}
</style>
